import { render, staticRenderFns } from "./Reserved.vue?vue&type=template&id=f0768dce&scoped=true&"
import script from "./Reserved.vue?vue&type=script&lang=js&"
export * from "./Reserved.vue?vue&type=script&lang=js&"
import style0 from "./Reserved.vue?vue&type=style&index=0&id=f0768dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0768dce",
  null
  
)

export default component.exports